import * as CONSTANTS from '../constants/actions/quick-search';

/**
 * @name applyHash
 * @function
 * @description Sets the provided parameters as active
 * @param {array} filters
 */
export const applyHash = (filters=[]) => {
    return dispatch => dispatch({ type: CONSTANTS.APPLY_HASH_CHANGE, payload: { filters } });
}